
import { updateItemInCollection } from "directus/src/operations";

export async function createRecurringConfig({ values, jobId }) {
  try {
    const query = {
      fields: [
        "id",
        "amount",
        "currency",
        "billing_interval",
        "billing_frequency",
        "billing_by_week_day",
        "billing_by_month_date",
        "billing_by_month",
      ],
    };

    const response = await updateItemInCollection(
      "jobs",
      jobId,
      {
        recurring_job_config: {
          ...values,
        },
      },
      query
    );
    return response;
  } catch (error) {
    console.error("Error creating recurring config:", error);
    throw error;
  }
}

export async function updateRecurringConfig({ id, values }) {
  try {
    const query = {
      fields: [
        "id",
        "amount",
        "currency",
        "billing_interval",
        "billing_frequency",
        "billing_by_week_day",
        "billing_by_month_date",
        "billing_by_month",
      ],
    };

    const response = await updateItemInCollection(
      "recurring_job_config",
      id,
      values,
      query
    );
    return response;
  } catch (error) {
    console.error("Error updating recurring config:", error);
    throw error;
  }
}
